import { SingletonRedirect } from "@/components/SingletonRedirect";

export function EmailProvidersList() {
  return <SingletonRedirect resource="email-providers" />;
}
